module.exports = __webpack_public_path__ + "img/check-stroke.fd3ec7b0.png";